export default __webpack_public_path__ + "2782574b2d1bf1f0a59e94e6a36b1cb7.png";